module.exports = "/../../dist/frontend/images/logo-new.svg?5a9eff96772dedbbcbd9b5e705c83aea";